<template>
  <div class="fullEditor">
    <Editor
      v-model="$v[validationGroupName].sections.airContract.$model"
      @blur="$v[validationGroupName].sections.airContract.$touch()"
      :validator="$v[validationGroupName].sections.airContract"
      :showDebugger="false"
      :disabled="isCompletedQuote" />
  </div>
</template>

<script>
import Editor from '@/components/_shared/Editor.vue'

export default {
  name: 'TabAirContract',
  inject: ['$v'],
  components: { Editor },
  props: {
    validationGroupName: {
      type: String,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    }
  }
}
</script>
